'use client';

import { Card, Flex, Text } from '@mantine/core';
import Link from 'next/link';
import { StyledButton } from '../../buttons';
import { useRouter } from 'next/navigation';
interface NoFolioFooterProps {
  mobile: boolean;
}
export function NoFolioFooter({
  mobile
}: NoFolioFooterProps) {
  const router = useRouter();
  return <Card p={mobile ? '10px' : undefined} style={{
    backgroundColor: 'f1f1f1',
    width: '100%',
    boxShadow: '0px -4px 6px rgba(0, 0, 0, 0.10), 0px 4px 6px rgba(0, 0, 0, 0.10)',
    borderRadius: '18px'
  }} data-sentry-element="Card" data-sentry-component="NoFolioFooter" data-sentry-source-file="NoFolioFooter.tsx">
      <Flex direction="row" gap="xs" justify="space-between" align="center" data-sentry-element="Flex" data-sentry-source-file="NoFolioFooter.tsx">
        <Text size={mobile ? '10px' : 'md'} w="70%" data-sentry-element="Text" data-sentry-source-file="NoFolioFooter.tsx">
          {mobile ? "You're missing a folio. Add one so you can" : "You're currently missing a folio. Add one so you can"}{' '}
          <Link href="/" passHref style={{
          textDecoration: 'none !important'
        }} data-sentry-element="Link" data-sentry-source-file="NoFolioFooter.tsx">
            <Text span c="blue" data-sentry-element="Text" data-sentry-source-file="NoFolioFooter.tsx">
              connect with users
            </Text>
          </Link>{' '}
          and{' '}
          <Link href="/iso" passHref style={{
          textDecoration: 'none !important'
        }} data-sentry-element="Link" data-sentry-source-file="NoFolioFooter.tsx">
            <Text span c="blue" data-sentry-element="Text" data-sentry-source-file="NoFolioFooter.tsx">
              collaborate on shoots
            </Text>
          </Link>
          .
        </Text>

        <StyledButton width="20%" disablePadding={mobile} extraSmallPadding={!mobile} noPadding={mobile} slimHeight text="ADD FOLIO" type="primary" onClick={() => router.push('/profile/')} data-sentry-element="StyledButton" data-sentry-source-file="NoFolioFooter.tsx" />
      </Flex>
    </Card>;
}